import { ProductCardSlotProps } from "../types/types";
import { componentMap } from "../product-card-components/componentMap";
import styles from "./ProductCardSlot.module.scss";

export const Slot = ({
  slotName,
  config,
  className,
  product,
  sizes,
  index: cardIndex,
  bordered = false,
  id,
}: ProductCardSlotProps) => {
  const components = config["product-card-slots"][slotName];

  if (!components || components.length < 1) {
    return null;
  }

  return (
    <div
      id={id}
      className={className}
      data-product-card-slot={slotName}
      data-testid={`product-card-slot-${slotName}`}
    >
      {components?.map((componentConfig, index) => {
        const Component = componentMap[componentConfig.name];
        const componentKey = `${componentConfig.name}-${index}`;

        const Element = Component ? (
          <Component
            key={bordered ? undefined : componentKey}
            configProps={componentConfig.props}
            product={product}
            sizes={sizes}
            index={cardIndex}
          />
        ) : null;

        return Element ? (
          bordered ? (
            <div className={styles.wrapper} key={componentKey}>
              {Element}
            </div>
          ) : (
            Element
          )
        ) : null;
      })}
    </div>
  );
};
